import { BrowserRouter, Route, Routes } from 'react-router-dom';
import BottomNavBar from './components/bottomNavBar';
import ApplyRefundPage from './pages/applyRefundPage';
import ApplySalesPage from './pages/applySalesPage';
import CertificatesPage from './pages/certificatesPage';
import ChangeAddressPage from './pages/changeAddressPage';
import CustomerPage from './pages/customerPage';
import CustomeraliPage from './pages/customeraliPage';

import DetailPage from './pages/detailPage';
import HomePage from './pages/homePage';
import RefundFeePage from './pages/refundFeePage';
import LogisticsPage from './pages/logisticsPage';
import OrderListPage from './pages/orderListPage';
import ProtocolPage from './pages/protocolPage';
import SearchPage from './pages/searchPage';
import SubmitSuccessPage from './pages/submitSuccessPage';
import SupCertificatesPage from './pages/supCertificatesPage';
import TrainDetailPage from './pages/trainDetailPage';
import FromHomePage from './pages/formHomePage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BottomNavBar />}>
          <Route path="/" element={<HomePage />} />
          <Route path="customer" element={<CustomerPage />} />
          <Route path="customerAli" element={<CustomeraliPage />} />
          <Route path="order" element={<OrderListPage />} />
        </Route>
        <Route path="product" element={<DetailPage />} />
        <Route path="refundFee" element={<RefundFeePage />} />
        <Route path="applySales" element={<ApplySalesPage />} />
        <Route path="logistics" element={<LogisticsPage />} />
        <Route path="changeAddress" element={<ChangeAddressPage />} />
        <Route path="supCertificates" element={<SupCertificatesPage />} />
        <Route path="applyRefund" element={<ApplyRefundPage />} />
        <Route path="submit" element={<SubmitSuccessPage />} />
        <Route path="train" element={<TrainDetailPage />} />
        <Route path="protocol" element={<ProtocolPage />} />
        <Route path="cer" element={<CertificatesPage />} />
        <Route path="orderList" element={<OrderListPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="formHome" element={<FromHomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
